<template>
    <nav class="px-nav px-nav-left">
        <button type="button" class="px-nav-toggle" data-toggle="px-nav">
            <span class="px-nav-toggle-arrow"></span>
            <span class="navbar-toggle-icon"></span>
            <span class="px-nav-toggle-label font-size-11">HIDE MENU</span>
        </button> 
        <ul class="px-nav-content">
            <li class="px-nav-box p-a-3 b-b-1" id="demo-px-nav-box">               
                <div class="font-size-16"><span class="font-weight-light">Campaign : </span><strong>{{ currentCampaignCode }}</strong></div>
            </li>
            <li v-if="resources.includes('dashboard')"  class="px-nav-item" v-bind:class="{ 'active': isActive_dashboard}">
                <a v-bind:href="'/dashboard'"><i class="px-nav-icon ion-ios-pulse-strong"></i><span class="px-nav-label">Dashboards</span></a>
            </li>
            <li v-if="resources.includes('campaign')" class="px-nav-item" v-bind:class="{ 'active': isActive_campaign}">
                <a v-bind:href="'/campaign/'+currentCampaignCode"><i class="px-nav-icon ion-ios-analytics"></i><span class="px-nav-label">Campaign Transaction</span></a>
            </li>
            <li v-if="resources.includes('redeem')" class="px-nav-item" v-bind:class="{ 'active': isActive_redeem}">
                <a v-bind:href="'/redeem'"><i class="px-nav-icon ion-pricetags"></i><span class="px-nav-label">Redeem</span></a>
            </li>
            <li v-if="resources.includes('accounts')" class="px-nav-item" v-bind:class="{ 'active': isActive_accounts}">
                <a v-bind:href="'/accounts'"><i class="px-nav-icon ion-ios-gear"></i><span class="px-nav-label">Account(Campaign)</span></a>
            </li>
            <li v-if="resources.includes('config')" class="px-nav-item" v-bind:class="{ 'active': isActive_config}">
                <a v-bind:href="'/config'"><i class="px-nav-icon ion-ios-gear"></i><span class="px-nav-label">Campaign Configuration</span></a>
            </li>

        </ul>  
    </nav> 
</template>

<script>
import $ from 'jquery'
import axios from '~/plugins/axios'
export default {
    data() {
        return { 
            resources:[],
            isActive_dashboard:false,
            isActive_campaign:false,
            isActive_redeem:false,
            isActive_config:false,
            isActive_accounts:false,
            currentCampaignCode:"",
            currentCampaignName:""
        }
    },
    mounted: function() {
        var pathArray = String(this.$route.name).split('-');
        var pathName = pathArray[0];
        if(this.$store.state.authUser && this.$store.state.authUser.rbac){
            this.currentCampaignCode = localStorage.getItem("now_campaign_code");
            this.currentCampaignName = localStorage.getItem("now_campaign_name");
            this.getUserRoleByCampaign(this.currentCampaignCode);
        }
        //dashboard page
        if(pathName == 'dashboard'){
            this.isActive_dashboard = true;
        }else{
            this.isActive_dashboard = false;
        }
        //campaign page
        if(pathName == 'campaign'){
            this.isActive_campaign = true;
        }else{
            this.isActive_campaign = false;
        }
        //redeem page
        if(pathName == 'redeem'){
            this.isActive_redeem = true;
        }else{
            this.isActive_redeem = false;
        }
        //config page
        if(pathName == 'config'){
            this.isActive_config = true;
        }else{
            this.isActive_config = false;
        }

        //accounts page
        if(pathName == 'accounts'){
            this.isActive_accounts = true;
        }else{
            this.isActive_accounts = false;
        }
    
    },
    methods: {
        async getUserRoleByCampaign (campaign_code) {
            let menu = [];
            let url = "/api/users/get_resource/"+campaign_code;
            let { data } = await axios.get(url);
            if(data.length > 0){
                this.resources = data;
                for (const resource of data) {
                    let str  = resource.name.split(":"); 
                    if(resource.permission.read == true){
                        menu.push(str[1]);
                    }
                } 
                menu = [...new Set(menu)];
            }
            this.resources = menu;            
            return this.resources;           
        }
    }
}
</script>